/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component } from '@angular/core';
import { NbLoginComponent } from '@nebular/auth';
import { convict } from '../../../pages/projects/common/config/convict';
import { dotenv } from '../../../pages/projects/common/config/dotenv';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
})
export class LoginComponent extends NbLoginComponent {
  convict = convict;
  dotenv = dotenv;

}